import { useLocation, useNavigate } from "react-router-dom"
import { useCallback, useEffect, useState } from "react"

//Components
import Loader from "../../components/loader"
import PlayerCard from "./components/player-card"
import ModalPlayers from "./components/modal-players"
import Snack from '../../components/snack'
import NavBar from './components/nav-bar'
import ModalPlayerInfo from "./components/modal-player-info"
import ClasesMuestraConfirm from "./components/clases-muestra-confirm"

//Extras
import { fontType } from "../../assets/extras"
import { dateToNatural, getAge, getCurrentDay, getCurrentTime, validateEmail } from "../../assets/validator"
import { addDoc, arrayUnion, collection, doc, getDoc, getDocs, increment, orderBy, query, updateDoc, where } from "firebase/firestore"
import { db } from "../../assets/connections"
import { main } from "../../assets/coach-assets/constants/colors"
import { IoIosClose } from "react-icons/io";

const CoachInfoClinic = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const data = location.state ? location.state.data : null

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")

            let snack = document.createElement("div")
            snack.classList.add("snack")

            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""

            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }

    const [variables, setVariables] = useState({
        ref: ref,
        data: data,
        loading: true,
        players: [],
        allPlayers: [],
        repoPlayers: [],
        lessons: [],
        change: false,
        modalP: false,
        selectedDate: new Date(),
        calendarShow: true,
        clasesMuestra: [],
        showClasesMuestra: false,
        fechaAux: null,
        readyToConfirm: null,
        clase: {
            profesor_clase: data.profesor_clase,
            nombre_clase: data.nombre_clase,
            descripcion_clase: data.descripcion_clase,
            dias_clase: data.dias_clase,
            hora_clase: getCurrentTime(),
            comentarios_clase: "",
            leccion_clase: "",
            alumnos_clase: [],
            duracion_clase: 1,
            wasGiven: true,
            reasons: "",
            details: ""
        }
    })

    //Variables para el control de la informacion del jugador seleccionado
    const [playerInfo, setPlayerInfo] = useState({
        show: false,
        edad: "",
        categoria: ""
    })
    const onPressed = (data) => {
        setPlayerInfo(prev => ({
            ...prev,
            edad: data.edad_jugador,
            categoria: data.categoria_jugador || "Sin categoría",
            show: true
        }))
    }

    //Actualiza la asistencia de cada jugador
    const onHandleCheck = useCallback((index) => {
        if (!variables.players[index].queued) {
            variables.players[index].queued = true
            variables.clase.alumnos_clase.push({
                id: variables.players[index].id,
                nombre: variables.players[index].nombre_jugador,
                asistencias: variables.players[index].asistencias
            })
            setVariables(prev => ({
                ...prev,
                change: !variables.change
            }))
        }
    }, [variables])

    //Actualiza la asistencia de cada jugador para quitarlo
    const onHandleNotCheck = useCallback((index, id) => {
        variables.players.map(v => v.id === id ? v.queued = false : v.queued)
        let aux = variables.clase.alumnos_clase.filter(v => v.id != id)

        setVariables(prev => ({
            ...prev,
            clase: {
                ...prev.clase,
                alumnos_clase: aux
            }
        }))
    }, [variables])

    //Formatea los dias de las clases
    const formatDays = (dias_clase) => {
        if (variables.data.id.split("-").length === 1 || variables.data.id.split("-")[2] === "TEMP") {
            let dias = ""
            let hora = ""
            dias_clase.map(v => {
                let dia = ""
                for (let i = 0; i < 3; i++) {
                    dia += v.dia[i]
                }
                if (dias) {
                    dias += " / " + dia
                } else {
                    dias = dia
                    hora = v.de + " a " + v.a
                }
            })
            return dias + " de " + hora
        }
        return "Hora asignada por el profesor"
    }

    //Funciones que realizan la finalizacion de la clase pero cuando la clase no fue impartida por alguna razon
    const finishClassNotGiven = (fecha) => {
        if(fecha != true && fecha != false){
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Vuelve a seleccionar tu fecha", "warning")
        } else {
            updateRegsNotGiven(fecha)
        }
    }
    //Obtenemos la referencia al documento donde va a ser almacenado
    const updateRegsNotGiven = async (fecha) => {
        //Primero obtenemos el documento de la clase que se va a registrar
        await getDoc(doc(doc(db, variables.ref), "Historial", variables.data.id)).then(r => {
            addRegNotGiven(r.ref, fecha)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }
    //Subimos el documento dentro de un nuevo archivo
    const addRegNotGiven = async (regRef, fecha) => {
        let newObject = {
            ...variables.clase,
            descripcion_clase: "",
            comentarios_clase: "",
            leccion_clase: "",
            alumnos_clase: [],
            jugadores_reposicion: [],
            fecha_clase: fecha
        }

        await addDoc(collection(regRef, "Historial"), {
            ...newObject
        }).then(r => {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Clase registrada!", "success")
            setTimeout(() => {
                navigate(-1, { replace: true });
            }, 2000)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    //Funcion que finaliza con clases muestra, y actualiza quienes si asistieron
    const onContinue = async () => {

        setVariables(prev => ({
            ...prev,
            showClasesMuestra: false
        }))

        //Primero actualizamos las clases muestra que se tuvieron en el momento
        variables.clasesMuestra.map(async (v, i) => {
            if (v.asistio === true) {
                await updateDoc(doc(db, "ClaseMuestra", v.id), {
                    asistio: true,
                    checked: true
                }).catch(e => {
                    console.log("No se pudeo actualizar a jugador de clase muestra")
                    console.log(e)
                })
            } else {
                await updateDoc(doc(db, "ClaseMuestra", v.id), {
                    asistio: false,
                    checked: true
                }).catch(e => {
                    console.log("No se pudeo actualizar a jugador de clase muestra")
                    console.log(e)
                })
            }
        })

        //Actualizamos la clase para restar a los jugadores de clase muestra
        if(typeof variables.fechAux === 'boolean'){
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Vuelve a seleccionar una fcha", "warning")
            }, 50)
        } else {
            await updateDoc(doc(doc(db, variables.ref), "Clases", variables.data.id), {
                clases_muestra: increment(-parseInt(variables.clasesMuestra.length))
            }).then(r => {
                updateRegs(variables.fechaAux)
            }).catch(e => {
                console.log("No se pudeo actualizar a jugador de clase muestra")
                console.log(e)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("Error de conexion", "error", 2000)
            })
        }

    }

    //Finaliza la clase
    const finishClass = async (fecha) => {
        let clasesMuestra = []
        await getClasesMuestra(fecha).then(r => {
            clasesMuestra = r
        })

        if (variables.clase.alumnos_clase.length > 0 ||
            variables.repoPlayers.length > 0) {
            if (variables.clase.leccion_clase != "") {
                if (variables.clase.duracion_clase == 0) {
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    showMessage("Debes seleccionar la duracion de la clase", "warning")
                } else {

                    //Primero validamos si no hay clases muestra para mostrar o no
                    if (clasesMuestra.length > 0) {
                        if(typeof fecha === 'boolean') {
                            setVariables(prev => ({
                                ...prev,
                                loading: false
                            }))
                            showMessage("Vuelve a seleccionar una fecha", "warning")
                        } else {
                            setVariables(prev => ({
                                ...prev,
                                clasesMuestra: clasesMuestra,
                                showClasesMuestra: true,
                                fechaAux: fecha,
                                loading: false
                            }))
                        }
                    } else {
                        if (variables.readyToConfirm == true || variables.readyToConfirm == false) {
                            setVariables(prev => ({
                                ...prev,
                                loading: false
                            }))
                            showMessage("Selecciona una fecha", "warning")
                        } else {
                            if (!validateDays()) {
                                setVariables(prev => ({
                                    ...prev,
                                    loading: false
                                }))
                                showMessage("El dia seleccionado no pertenece a los dias de clase", "warning")
                            } else {
                                if(typeof fecha === 'boolean') {
                                    console.log(fecha)
                                    setVariables(prev => ({
                                        ...prev,
                                        loading: false
                                    }))
                                    showMessage("Vuelve a seleccionar una fecha", "warning")
                                } else {
                                    updateRegs(fecha)
                                }
                            }
                        }
                    }
                }
            } else {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("Debes seleccionar una leccion", "warning")
            }
        } else {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("No hay asistencias registradas", "warning")
        }
    }
    //Funcion que obtiene las clases muestra
    const getClasesMuestra = async (fecha) => {
        //Hacemos la busqueda las clases muestra
        /**
         * 1. Por academia (Path/Referencia)
         * 2. Por ID de clase
         * 3. Por fecha
         * 4. Por asistio === false
        */

        return new Promise(async resolve => {
            const path = doc(doc(db, variables.ref), "Clases", variables.data.id).path
            await getDocs(query(collection(db, "ClaseMuestra"), where("isReserved", "==", true), where("ref", "==", path), where("id_clase", "==", variables.data.id.split("-")[0]), where("fecha_clase", "==", fecha), where("asistio", "==", false), where("checked", "==", false))).then(r => {
                let aux = []
                r.docs.map(v => {
                    aux.push({
                        id: v.id,
                        comentarios_clase: "",
                        ...v.data()
                    })
                })

                resolve(aux)

            }).catch(e => {
                console.log(e)
                console.log("Error al obtener clases muestra")
                showMessage("Error al obtener clases muestra", "error")
            })
        })
    }

    //Funcion que valida si el dia seleccionado esta dentro de la lista de dais
    const validateDays = () => {
        const dayNumber = getCurrentDay(variables.selectedDate.getDay());
        const dias = variables.data.dias_clase.map(v => v.dia);

        return dias.includes(dayNumber)
    }

    //Funcion que controla el cambio de fecha
    const handleDateChange = (e) => {
        const [year, month, day] = e.target.value.split("-");
        const sD = new Date(year, month - 1, day);

        const aux = `${year}-${month}-${day}`;

        setVariables(prev => ({
            ...prev,
            selectedDate: sD,
            readyToConfirm: aux
        }));
    }
    const hanldeNotGivenDataChage = (e) => {
        const value = e.target.value;

        const [year, month, day] = value.split("-").map(Number);

        const sD = new Date(year, month - 1, day);

        let aux =
            sD.getFullYear() +
            "-" +
            (sD.getMonth() + 1) +
            "-" +
            sD.getDate();
        setVariables((prev) => ({
            ...prev,
            selectedDate: sD,
            calendarShow: false,
            readyToConfirm: aux
        }));
    }

    //Sube el registro a la bd
    const updateRegs = async (fecha) => {
        //Primero obtenemos el documento de la clase que se va a registrar
        await getDoc(doc(doc(db, variables.ref), "Historial", variables.data.id)).then(r => {
            addReg(r.ref, fecha)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    const addReg = async (regRef, fecha) => {
        await addDoc(collection(regRef, "Historial"), {
            ...variables.clase,
            jugadores_reposicion: variables.repoPlayers,
            fecha_clase: fecha,
            nombre_profesor: variables.data.nombre_profesor,
            clasesMuestra: variables.clasesMuestra.map(v => ({ id: v.id, nombre: v.nombre }))
        }).then(r => {
            updatingAsistances(fecha, r.id)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }
    //Actualiza las asistencias de todos los jugadores
    const updatingAsistances = (fecha, reg_id) => {
        //Priero tenemos que actualizar todas las asistencias de los alumnos
        let counter = 0
        variables.clase.alumnos_clase.map(v => {
            if (updateAsistance(v.id, fecha, reg_id)) {
                counter++
            }
        })

        variables.repoPlayers.map(v => {
            if (updateAsistance(v.id, fecha, reg_id)) {
                counter++
            }
        })

        if (counter == variables.clase.alumnos_clase.length + variables.repoPlayers.length) {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Clase concluida!", "success")
            setTimeout(() => {
                navigate(-1, { replace: true });
            }, 2000)
        } else {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Clase concluida! Algunso jugadores no fueron actualizados", "warning")
            setTimeout(() => {
                navigate(-1, { replace: true });
            }, 2000)
        }
    }
    const updateAsistance = async (id, fecha, reg_id) => {
        await updateDoc(doc(doc(db, variables.ref), "Jugador", id),
            {
                asistencias: arrayUnion({
                    fecha_clase: fecha,
                    nombre_clase: variables.data.nombre_clase,
                    profesor_clase: variables.data.nombre_profesor,
                    hora_clase: formatDays(variables.data.dias_clase),
                    id: reg_id
                })
            }
        ).then(r => {
            return true
        })
        return false
    }

    //Funcion que quita a un jugador de reposicion
    const takeOutPlayer = (index, data) => {
        variables.repoPlayers.splice(index, 1)
        variables.allPlayers.push(data)

        setVariables(prev => ({
            ...prev,
            change: !prev.change
        }))
    }

    //Funcion que añade al jugador a la lista de jugadores asistidos
    const addNewPlayer = (id, nombre, index, asistencias, correo_jugador, edad_jugador, telefono_jugador) => {
        let players1 = variables.allPlayers
        let players2 = variables.repoPlayers

        players2.push({
            id,
            nombre_jugador: nombre,
            asistencias,
            correo_jugador,
            edad_jugador,
            telefono_jugador,
            categoria_jugador: variables.allPlayers[index].categoria_jugador || "Sin categoría"
        })
        players1.splice(index, 1)

        setVariables(prev => ({
            ...prev,
            change: !prev.change,
            allPlayers: players1,
            repoPlayers: players2
        }))

        console.log(variables.repoPlayers)
    }

    const getAllPlayers = async () => {
        setVariables(prev => ({
            ...prev,
            loading: true
        }))
        if (variables.allPlayers.length == 0) {
            await getDocs(query(collection(doc(db, variables.ref), "Jugador"), orderBy("nombre_jugador", "asc"))).then(r => {
                let aux = []
                r.docs.map((v, i) => {
                    aux.push({
                        id: v.id,
                        nombre_jugador: v.data().nombre_jugador,
                        asistencias: v.data().asistencias.length,
                        telefono_jugador: v.data().telefono_jugador,
                        correo_jugador: validateEmail(v.data().correo_jugador) === true ? v.data().correo_jugador : "El jugador no tiene correo",
                        edad_jugador: getAge(v.data().edad_jugador),
                        categoria_jugador: v.data().categoria_jugador || "Sin categoría"
                    })
                })

                //Eliminamos a los jugadores que ya estan en nuestra lista
                if (variables.players) {
                    for (let i = 0; i < variables.players.length; i++) {
                        for (let j = 0; j < aux.length; j++) {
                            if (variables.players[i].id == aux[j].id) {
                                aux.splice(j, 1)
                                break
                            }
                        }
                    }
                }

                setVariables(prev => ({
                    ...prev,
                    allPlayers: aux,
                    modalP: true,
                    loading: false
                }))
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("Error de conexion", "error", 2000)
            })
        } else {
            setVariables(prev => ({
                ...prev,
                loading: false,
                modalP: true
            }))
        }
    }

    //Obtiene los datos de la clase, es decir, jugadores, etc.
    const getData = async () => {
        const idClase = variables.data.id.split("-")

        await getDocs(query(collection(doc(db, variables.ref), "Jugador"), where("clases_jugador", "array-contains", idClase[0]))).then(r => {
            if (r.docs.length > 0) {
                let aux = []
                r.docs.map(v => {
                    let d = v.data()

                    let newObject = {
                        id: v.id,
                        nombre_jugador: d.nombre_jugador,
                        asistencias: d.asistencias.length,
                        telefono_jugador: d.telefono_jugador,
                        correo_jugador: validateEmail(d.correo_jugador) === true ? d.correo_jugador : "El jugador no tiene correo",
                        edad_jugador: getAge(d.edad_jugador),
                        categoria_jugador: d.categoria_jugador || "Sin categoría",
                        queued: false
                    }
                    aux.push(newObject)
                })

                getLessons(aux)
            } else {
                getLessons()
            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }
    //obtiene las lecciones de las clases
    const getLessons = async (players) => {
        await getDocs(query(collection(db, "Lecciones"))).then(r => {
            let aux = []
            r.docs.map(v => {
                aux.push(v.id)
            })

            setVariables(prev => ({
                ...prev,
                players: players,
                lessons: aux,
                loading: false
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    useEffect(() => {
        const token = localStorage.getItem("authTokenCoach")

        if (!token) {
            navigate("/coach", {
                replace: true
            })
        } else {
            getData()
        }
    }, [])

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: "20px",
                    margin: "0 auto",
                    paddingBottom: 40
                }}
            >

                <Snack />

                <NavBar
                    title={variables.data.nombre_clase}
                />

                <ModalPlayers
                    modalP={variables.modalP}
                    variables={variables}
                    setVariables={setVariables}
                    players={variables.allPlayers}
                    addNewPlayer={addNewPlayer}
                />

                <ModalPlayerInfo
                    playerInfo={playerInfo}
                    setPlayerInfo={setPlayerInfo}
                />

                <ClasesMuestraConfirm
                    setVariables={setVariables}
                    variables={variables}
                    onContinue={onContinue}
                />

                {
                    variables.clase.wasGiven === true ?
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: 700 }}>

                            {/* Switch */}
                            <div style={{ display: "flex", alignItems: "center", paddingLeft: 28, width: "100%", marginTop: 0 }}>
                                <input
                                    type="checkbox"
                                    checked={variables.clase.wasGiven}
                                    onChange={() =>
                                        setVariables((prev) => ({
                                            ...prev,
                                            clase: {
                                                ...prev.clase,
                                                wasGiven: !prev.clase.wasGiven
                                            },
                                            readyToConfirm: null
                                        }))
                                    }
                                />
                                <span style={{ marginLeft: 10, fontFamily: fontType.text }}>La clase fue impartida correctamente</span>
                            </div>

                            <h3 style={{ fontFamily: fontType.title, marginTop: 20, marginBottom: 10 }}>Asistencias</h3>

                            {/* Players */}
                            <div style={{
                                width: "70%",
                                maxWidth: 800
                            }}>
                                {
                                    variables.players && variables.players.length > 0 ? (
                                        variables.players.map((player, index) => (
                                            <div>
                                                <PlayerCard
                                                    data={player}
                                                    delay={index}
                                                    func={onHandleCheck}
                                                    funcOut={onHandleNotCheck}
                                                    onClick={onPressed}
                                                />
                                            </div>
                                        ))
                                    ) : (
                                        <p>No hay jugadores</p>
                                    )
                                }
                            </div>

                            {/* Reposiciones */}
                            {
                                variables.repoPlayers.length > 0 ?
                                    <h3 style={{
                                        width: "100%",
                                        textAlign: "center",
                                        fontSize: 18,
                                        fontFamily: fontType.title,
                                        marginTop: 20,
                                        marginBottom: 10

                                    }}> Reposiciones </h3>
                                    : null
                            }
                            <div style={{
                                width: "70%",
                                maxWidth: 800
                            }}>
                                {
                                    variables.repoPlayers !== undefined ?
                                        variables.repoPlayers.length > 0 ?
                                            variables.repoPlayers.map((v, i) => {
                                                //Funcion que formatea el nombre de los jugadores para que quepan en el recuadro
                                                const formatName = (nombre) => {
                                                    let name = ""
                                                    let cont = 0
                                                    for (let i = 0; i < nombre.length; i++) {
                                                        name += nombre[i]
                                                        cont++

                                                        if (cont == 22) {
                                                            break
                                                        }
                                                    }

                                                    if (cont == 22) {
                                                        return name + "..."
                                                    } else {
                                                        return name
                                                    }
                                                }

                                                return (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            width: "100%",
                                                            padding: "10px 15px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: 8,
                                                            marginBottom: 10,
                                                            height: 60,
                                                            marginTop: 20,
                                                            backgroundColor: "white",
                                                            boxShadow: "0px 2px 5px rgba(0,0,0,0.1)", // equivalente a elevation
                                                        }}
                                                    >
                                                        <div>
                                                            <p
                                                                style={{ fontSize: 16, fontWeight: "bold", cursor: "pointer", fontFamily: fontType.text }}
                                                            >
                                                                {formatName(v.nombre_jugador)}
                                                            </p>
                                                        </div>

                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                                            <button
                                                                style={{
                                                                    width: 50,
                                                                    height: "100%",
                                                                    border: "none",
                                                                    background: "transparent",
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                                onClick={() => takeOutPlayer(i, v)}
                                                            >
                                                                <IoIosClose size={30} color="red" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            : null
                                        : null
                                }
                            </div>

                            {/* Botón Buscar Jugador */}
                            <button
                                onClick={getAllPlayers}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 15,
                                    borderRadius: 10,
                                    backgroundColor: main,
                                    color: "white",
                                    fontFamily: fontType.title,
                                    fontSize: 16,
                                    marginTop: 10,
                                    maxWidth: 250,
                                    minWidth: 250,
                                    border: "none",
                                    cursor: "pointer",
                                }}
                            >
                                BUSCAR JUGADOR
                            </button>

                            {/* Lecciones */}
                            <h3 style={{ marginTop: 30, fontSize: 18, fontFamily: fontType.title }}>
                                Lecciones
                            </h3>

                            <div style={{
                                width: "90%",
                                border: "1px solid #ddd",
                                borderRadius: 10,
                                marginTop: 5,
                                padding: 5,
                            }}>
                                <select
                                    value={variables.clase.leccion_clase}
                                    onChange={(e) =>
                                        setVariables(prev => ({
                                            ...prev,
                                            clase: {
                                                ...prev.clase,
                                                leccion_clase: e.target.value
                                            }
                                        }))
                                    }
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        color: "black",
                                        backgroundColor: "white",
                                        borderRadius: "10px",
                                        border: "none"
                                    }}
                                >
                                    <option value="">Seleccionar lección</option>
                                    {variables.lessons.map((v, i) => (
                                        <option key={i} value={v}>{v}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Comentarios */}
                            <h3 style={{ marginTop: 30, textAlign: "center", fontSize: 18, fontFamily: fontType.title }}>
                                Comentarios
                            </h3>
                            <textarea

                                placeholder="Añade un comentario sobre la clase..."
                                value={variables.clase.comentarios_clase}
                                onChange={(e) =>
                                    setVariables(prev => ({
                                        ...prev,
                                        clase: { ...prev.clase, comentarios_clase: e.target.value }
                                    }))
                                }
                                maxLength={250}
                                cols={100}
                                style={{
                                    fontSize: 16,
                                    width: "80%",
                                    color: "black",
                                    marginTop: 10,
                                    padding: 8,
                                    borderRadius: 5,
                                    border: "1px solid #ccc",
                                    resize: "none"
                                }}
                            />

                            {/* Duración de clase */}
                            <h4 style={{ fontFamily: fontType.title, marginTop: 20, width: "90%" }}>
                                Duración de clase
                            </h4>
                            <div style={{ marginTop: 5, width: "90%" }}>
                                <div style={{
                                    width: "100%",
                                    border: "1px solid #ddd",
                                    borderRadius: 10,
                                    marginTop: 5,
                                }}>
                                    <select
                                        value={variables.clase.duracion_clase}
                                        onChange={(e) =>
                                            setVariables(prev => ({
                                                ...prev,
                                                clase: { ...prev.clase, duracion_clase: parseInt(e.target.value) }
                                            }))
                                        }
                                        style={{
                                            width: "100%",
                                            padding: "10px",
                                            color: "black",
                                            backgroundColor: "white",
                                            borderRadius: "10px",
                                            border: "none",
                                        }}
                                    >
                                        {[...Array(8)].map((_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1} Hora{i > 0 ? "s" : ""}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {
                                <div style={{ marginTop: 35 }}>
                                    <p style={{
                                        fontFamily: fontType.title
                                    }}>Seleccionar fecha: </p>
                                    <input
                                        type="date"
                                        onInput={handleDateChange}
                                        style={{
                                            padding: 8,
                                            fontSize: 16,
                                            borderRadius: 5,
                                            border: "1px solid #ccc",
                                            marginBottom: 20
                                        }}
                                    />
                                </div>
                            }

                            {/* Botón confirmacion */}
                            {
                                variables.readyToConfirm != null ?
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        width: "70%"
                                    }}>
                                        <button
                                            style={{
                                                marginTop: 10,
                                                marginBottom: 10,
                                                backgroundColor: "#4e6b4eff",
                                                width: "100%",
                                                borderRadius: 10,
                                                borderStyle: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 18,
                                                padding: 10,
                                                border: "none",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {

                                                setVariables((prev) => ({
                                                    ...prev,
                                                    loading: true,
                                                }));
                                                finishClass(variables.readyToConfirm);
                                            }}
                                        >
                                            CONFIRMAR CLASE
                                        </button>
                                        <p style={{
                                            fontFamily: fontType.title
                                        }}>{dateToNatural(variables.selectedDate)}</p>
                                    </div>
                                    : null
                            }

                        </div>
                        :
                        <div
                            style={{
                                flex: 1,
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                            {/* Título */}
                            <h2 style={{ fontFamily: fontType.title }}>
                                {variables.data.nombre_clase}
                            </h2>

                            {/* Switch */}
                            <div
                                style={{
                                    width: "100%",
                                    padding: 20,
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={variables.clase.wasGiven}
                                    onChange={() =>
                                        setVariables((prev) => ({
                                            ...prev,
                                            clase: {
                                                ...prev.clase, wasGiven:
                                                    !prev.clase.wasGiven
                                            },
                                            readyToConfirm: null
                                        }))
                                    }
                                />
                                <span style={{ marginLeft: 10, fontFamily: fontType.text }}>La clase no pudo ser impartida</span>
                            </div>

                            {/* Picker razones */}
                            <div
                                style={{
                                    width: "90%",
                                    border: "1px solid #ddd",
                                    borderRadius: 10,
                                    marginTop: 5,
                                }}
                            >
                                <select
                                    value={variables.clase.reasons}
                                    onChange={(e) =>
                                        setVariables((prev) => ({
                                            ...prev,
                                            clase: {
                                                ...prev.clase,
                                                reasons: e.target.value
                                            },
                                        }))
                                    }
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        color: "black",
                                        backgroundColor: "white",
                                        borderRadius: "10px",
                                        border: "none",
                                    }}
                                >
                                    <option value="">Selecciona una razón</option>
                                    <option value="Por lluvias">Por lluvias</option>
                                    <option value="Falta de alumnos">Falta de alumnos</option>
                                    <option value="Otras razones">Otras razones</option>
                                </select>
                            </div>

                            {/* Picker duración */}
                            {
                                variables.clase.reasons !== "" && (
                                    <div style={{ width: "100%" }}>
                                        <h3
                                            style={{
                                                fontFamily: fontType.title,
                                                marginTop: 20,
                                                fontSize: 18,
                                                width: "100%",
                                                textAlign: "center",
                                            }}
                                        >
                                            Duración de clase
                                        </h3>
                                        <div
                                            style={{
                                                width: "100%",
                                                border: "1px solid #ddd",
                                                borderRadius: 10,
                                                marginTop: 5,
                                            }}
                                        >
                                            <select
                                                value={variables.clase.duracion_clase}
                                                onChange={(e) =>
                                                    setVariables((prev) => ({
                                                        ...prev,
                                                        clase: { ...prev.clase, duracion_clase: parseInt(e.target.value) },
                                                    }))
                                                }
                                                style={{
                                                    width: "100%",
                                                    padding: "10px",
                                                    color: "black",
                                                    backgroundColor: "white",
                                                    borderRadius: "10px",
                                                    border: "none",
                                                }}
                                            >
                                                <option value="">Selecciona duración</option>
                                                {[...Array(8)].map((_, i) => (
                                                    <option key={i + 1} value={i + 1}>
                                                        {i + 1} Hora{i > 0 ? "s" : ""}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                )
                            }

                            {/* Input otras razones */}
                            {
                                variables.clase.reasons === "Otras razones" && (
                                    <input
                                        type="text"
                                        placeholder="Razones..."
                                        maxLength={250}
                                        style={{
                                            width: "80%",
                                            border: "1px solid #ddd",
                                            height: 40,
                                            borderRadius: 5,
                                            marginTop: 20,
                                            padding: 5,
                                            fontSize: 16,
                                            color: "black",
                                        }}
                                        onBlur={(e) =>
                                            setVariables((prev) => ({
                                                ...prev,
                                                clase: {
                                                    ...prev.clase,
                                                    details: e.target.value
                                                },
                                            }))
                                        }
                                    />
                                )
                            }

                            {/* DatePicker */}
                            {
                                <div>
                                    <p style={{
                                        fontFamily: fontType.title,
                                        marginTop: 35
                                    }}>Seleccionar fecha: </p>
                                    <input
                                        type="date"
                                        style={{ marginTop: 20 }}
                                        onInput={hanldeNotGivenDataChage}
                                    />
                                </div>
                            }

                            {/* Botón confirmacion */}
                            {
                                variables.readyToConfirm != null ?
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        width: "70%"
                                    }}>
                                        <button
                                            style={{
                                                marginTop: 20,
                                                marginBottom: 10,
                                                backgroundColor: "#4e6b4eff",
                                                width: "100%",
                                                borderRadius: 10,
                                                borderStyle: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 18,
                                                padding: 10,
                                                border: "none",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {
                                                setVariables((prev) => ({
                                                    ...prev,
                                                    loading: true,
                                                }));
                                                finishClassNotGiven(variables.readyToConfirm);
                                            }}
                                        >
                                            CONFIRMAR CLASE
                                        </button>
                                        <p style={{
                                            fontFamily: fontType.title
                                        }}>{dateToNatural(variables.selectedDate)}</p>
                                    </div>
                                    : null
                            }

                        </div>
                }

            </div>
        )
}

export default CoachInfoClinic

/**
 * if(!location.state){
        navigate("/coach/home", {
            replace: true
        })
    }
 */